export default "__VITE_ASSET__kp6_w5$p__"